(function() {
  const path = window.location.pathname;
  
  // Gemeinsames CSS für alle System-Seiten
  const sharedStyles = `
    #custom_side_wrapper {
      background: #F7ECDC !important;
    }
  `;
  
  // Seitenspezifisches CSS
  const pageStyles = {
    '/challenge': `
      .shopify-challenge__message {
        color: #333 !important;
      }
    `
  };

  const systemPages = ['/account/subscribe', '/challenge'];
  const isSystemPage = systemPages.some(page => path.includes(page));

  if (isSystemPage) {
    let css = sharedStyles;
    
    // Seitenspezifische Styles hinzufügen falls vorhanden
    for (const [pagePath, pageCSS] of Object.entries(pageStyles)) {
      if (path.includes(pagePath)) {
        css += pageCSS;
      }
    }
    
    const style = document.createElement('style');
    style.id = 'custom-page-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }
})();